<template>
	<div class="col-xs-12">
		<div class="print-layout-2">
			<div class="row print-layout-2__main-image-outer">
				<div class="col-xs-12 text-center">
					<img class="print-layout-2__main-image" :class="{'resized-image' : _idCliente != 33}" :src="_img2" />
				</div>
			</div>

			<div class="row">
				<div class="col-xs-12">
					<div class="print-layout-2__header-body">
						<h1 class="text-center print-layout-2__header-title">
							{{ _labelRelatorioPrevencao.titulo.toUpperCase() }}
						</h1>
						<p class="text-justify">
							OS RELATOS DAS OCORRÊNCIAS OU DAS OBSERVAÇÕES AQUI APRESENTADAS TÊM COMO ÚNICA FINALIDADE AUMENTAR A SEGURANÇA E
							DEVEM SER BASEADOS EM FATOS OU EXPERIÊNCIAS PESSOAS QUE, EM SUA OPINIÃO, POSSAM CONTRIBUIR PARA EVITAR A OCORRÊNCIA
							DE UM ACIDENTE. OS DADOS AQUI CONTIDOS SERÃO PARA USO EXCLUSIVO DA SEGURANÇA OPERACIONAL. SE ASSINADO O REMETENTE
							SERÁ INFORMADO SOBRE AS MEDIDAS ADOTADAS.
						</p>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-xs-12 print-layout-2__first-section">
					<div class="print-layout-2__first-section-side-title">
						<p class="text-center print-layout-2__first-section-side-title-text">DADOS GERAIS</p>
					</div>
					<div class="print-layout-2__first-section-body">
						<h1 class="text-center print-layout-2__first-section-body-title">{{ comando }}</h1>
						<p class="print-layout-2__first-section-body-first-text">
							<span><strong>LOCAL:</strong> {{ relatorio.local }}</span>

							<span><strong>DATA E HORA:</strong> {{ relatorio.data }}</span>
						</p>
						<p class="print-layout-2__first-section-body-last-text">
							<span><strong>PESSOAL ENVOLVIDO E/OU ANV:</strong> {{ relatorio.envolvidos }}</span>
						</p>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-xs-12 print-layout-2__second-section">
					<div class="print-layout-2__second-section-side-title">
						<p class="print-layout-2__second-section-side-title-text">OCORRÊNCIA</p>
					</div>
					<div class="print-layout-2__second-section-body">
						<p class="print-layout-2__second-section-body-text">
							<span class="print-layout-2__second-section-body-text-title">SITUAÇÃO:</span>
							{{ relatorio.descricao }}
						</p>

						<div class="print-layout-2__second-section-body-text-footer">
							<div>
								<span class="text-center print-layout-2__second-section-body-text-relator" style=""
									><strong>RELATOR:</strong> {{ relatorio.relator }}</span
								>
							</div>

							<div>
								<span class="text-center print-layout-2__second-section-body-text-assinatura">ASSINATURA</span>
							</div>
						</div>
					</div>
				</div>
			</div>

			<div class="row">
				<div class="col-xs-12 print-layout-2__last-section">
					<div class="print-layout-2__last-section-side-title">
						<p class="print-layout-2__last-section-side-title-text">ENCAMINHAMENTO E/OU PROVIDÊNCIAS DO CIS</p>
					</div>
					<div class="print-layout-2__last-section-body">
						<p class="print-layout-2__last-section-body-first-text">DO:</p>

						<p class="print-layout-2__last-section-body-second-text">AO:</p>

						<p class="print-layout-2__last-section-body-last-text">DATA:</p>
					</div>

					<div class="col-xs-12 col-sm-12 col-md-6 col-lg-5 no-print pull-right" v-if="relatorio.anexos.length > 0">
						<label style="margin-top: 20px; font-size: 14pt"
							>{{ _traducao('global', 'lista').capitalizeFirst() }} {{ _traducao('global', 'de').toLowerCase() }}
							{{ _traducao('global', 'anexos') }}
						</label>
						<ul style="list-style-type: none; padding-left: 2%">
							<li v-for="anexo of relatorio.anexos" :key="anexo.caminho">
								<a @click="abreLink(anexo.link)"> {{ anexo.nome }} </a>
							</li>
						</ul>
					</div>
				</div>
			</div>
		</div>
	</div>
</template>

<script>
export default {
	name: 'RelatorioPrevencaoPrintLayout2',

	props: {
		relatorio: {
			type: Object,
			required: true
		}
	},
	data()
	{
		return {
			comando: '',
		}
	},
	created(){
		this._getParametro(64).then((valor) => (this.comando = valor))
	},

	methods: {
		abreLink(url) {
			let a = document.createElement('a')
			a.href = url
			a.target = '_blank'
			document.body.appendChild(a)
			a.click()
		}
	}
}
</script>

<style scoped>
.print-layout-2 {
	border: 10px dashed #f0ad4e;
	padding: 10px;
}

.print-layout-2__main-image-outer {
	margin-bottom: 30px;
}

.print-layout-2__main-image {
	width: 450px;
	opacity: 0.6;
}

.print-layout-2__header-body {
	border-top: 1px solid #b9b2b2;
	border-bottom: 1px solid #b9b2b2;
}

.print-layout-2__header-title {
	font-size: 18pt;
	font-weight: 700 !important;
}

.print-layout-2__first-section {
	display: flex;
}

.print-layout-2__first-section-side-title {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 10%;
	font-weight: bold;
	border-right: 1px solid #b9b2b2;
	border-bottom: 1px solid #b9b2b2;
	padding: 25px 0;
}

.print-layout-2__first-section-side-title-text {
	transform: rotate(270deg);
	font-size: 9.5pt;
	margin: 0;
}

.print-layout-2__first-section-body {
	display: flex;
	flex-flow: column nowrap;
	width: 90%;
	padding: 0 15px 10px 15px;
	border-bottom: 1px solid #b9b2b2;
}

.print-layout-2__first-section-body-title {
	font-size: 12pt;
}

.print-layout-2__first-section-body-first-text {
	display: flex;
	justify-content: space-between;
	font-size: 10.5pt;
	padding-top: 17px;
}

.print-layout-2__first-section-body-last-text {
	display: flex;
	font-size: 10.5pt;
}

.print-layout-2__second-section {
	display: flex;
}

.print-layout-2__second-section-side-title {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 10%;
	font-weight: bold;
	border-right: 1px solid #b9b2b2;
	border-bottom: 1px solid #b9b2b2;
	padding: 50px 0;
}

.print-layout-2__second-section-side-title-text {
	text-align: center;
	transform: rotate(270deg);
	font-size: 9.5pt;
	margin: 0;
}

.print-layout-2__second-section-body {
	display: flex;
	flex-flow: column nowrap;
	width: 90%;
	padding: 15px;
	border-bottom: 1px solid #b9b2b2;
}

.print-layout-2__second-section-body-text {
	font-size: 10pt;
}

.print-layout-2__second-section-body-text-title {
	font-size: 10.5pt;
	font-weight: bold;
}

.print-layout-2__second-section-body-text-footer {
	display: flex;
	justify-content: space-between;
	align-items: flex-end;
	padding-top: 50px;
}

.print-layout-2__second-section-body-text-relator {
	display: block;
	border-top: 1px solid #b9b2b2;
	width: 250px;
	padding-top: 4px;
}

.print-layout-2__second-section-body-text-assinatura {
	display: block;
	border-top: 1px solid #b9b2b2;
	width: 250px;
	font-weight: bold;
	padding-top: 4px;
}

.print-layout-2__last-section {
	display: flex;
}

.print-layout-2__last-section-side-title {
	display: flex;
	justify-content: center;
	align-items: center;
	width: 10%;
	font-weight: bold;
	border-right: 1px solid #b9b2b2;
	padding: 50px 0;
}

.print-layout-2__last-section-side-title-text {
	text-align: center;
	transform: rotate(270deg);
	font-size: 9.5pt;
	margin: 0;
}

.print-layout-2__last-section-body {
	display: flex;
	flex-flow: column nowrap;
	width: 90%;
	padding: 0 15px 10px 15px;
}

.print-layout-2__last-section-body-first-text {
	font-size: 10.5pt;
	padding-top: 15px;
	font-weight: bold;
}

.print-layout-2__last-section-body-second-text {
	font-size: 10.5pt;
	height: 150px;
	font-weight: bold;
}

.print-layout-2__last-section-body-last-text {
	font-size: 10.5pt;
	padding-top: 15px;
	font-weight: bold;
}

.resized-image{
	width:150px;
	margin-top:10px;
}
</style>